<template>
    <div>
        <div class="back">
            <a href="/function"><img src="/static/tutorial/back.png" alt=""></a>
        </div>
        <div class="introduction">
            
            <h1>{{this.EventBus.getText("interface_title")}}</h1>
            <img :src=interface_img alt="">
        </div>

        
        <div class="container">
            <h1>{{this.EventBus.getText("interface_screen")}}</h1>
            <img :src=screen_img alt="">
            <div class="item" v-for="data in datas" v-bind:key="data.index">
                    <img :src=data.img  alt="">
                    <hr width=50%>
                    <h2>{{data.subject}}</h2>
                    <p>{{data.explain[0].ex1}}</p>
                    <p><b>{{data.explain[0].ex2}}</b></p>

            </div>
        </div>
        <js/>

    </div>
</template>
<script>
import Interface from '../../assets/language/interface.json'
export default {
    beforeCreate() {
        this.EventBus.loadLanguage(Interface);
    },
    created(){
        this.push(this.index);
    },
    data(){
        return{
            subject: undefined,
            img: undefined,
            explain: [],
            index :0,
            interface_img: this.EventBus.getText("interface_img"),
            screen_img: this.EventBus.getText("interface_screen_img"),
            datas: [
                {
                    index: 1,
                    img :  this.EventBus.getText("interface_center_img"),
                    subject: this.EventBus.getText("interface_center"),
                    explain: [
                        {
                            ex1: this.EventBus.getText("interface_center_ex1"), 
                            ex2 : this.EventBus.getText("interface_center_ex2"),
                        },
                    ],  
                },
                {
                    index: 2,
                    img : this.EventBus.getText("interface_moving_img"),
                    subject: this.EventBus.getText("interface_moving"),
                    explain: [
                        {
                            ex1: this.EventBus.getText("interface_moving_ex1"), 
                            ex2 : this.EventBus.getText("interface_moving_ex2"),
                        },
                    ], 
                },
                {
                    index: 3,
                    img : this.EventBus.getText("interface_home_img"),
                    subject: this.EventBus.getText("interface_home"),
                    explain: [
                        {
                            ex1: this.EventBus.getText("interface_home_ex1"), 
                            ex2 : this.EventBus.getText("interface_home_ex2"),
                        },
                    ], 
                },
                {
                    index: 4,
                    img : this.EventBus.getText("interface_above_img"),
                    subject: this.EventBus.getText("interface_above"),
                    explain: [
                        {
                            ex1: this.EventBus.getText("interface_above_ex1"), 
                            ex2 : this.EventBus.getText("interface_above_ex2"),
                        },
                    ], 
                },
                {
                    index: 5,
                    img : this.EventBus.getText("interface_below_img"),
                    subject: this.EventBus.getText("interface_below"),
                    explain: [
                        {
                            ex1: this.EventBus.getText("interface_below_ex1"), 
                            ex2 : this.EventBus.getText("interface_below_ex2"),
                        },
                    ], 
                },
                {
                    index: 6,
                    img : this.EventBus.getText("interface_left_img"),
                    subject: this.EventBus.getText("interface_left"),
                    explain: [
                        {
                            ex1: this.EventBus.getText("interface_left_ex1"), 
                            ex2 : this.EventBus.getText("interface_left_ex2"),
                        },
                    ], 
                },
                {
                    index: 7,
                    img : this.EventBus.getText("interface_right_img"),
                    subject: this.EventBus.getText("interface_right"),
                    explain: [
                        {
                            ex1: this.EventBus.getText("interface_right_ex1"), 
                            ex2 : this.EventBus.getText("interface_right_ex2"),
                        },
                    ], 
                },
                {
                    index: 8,
                    img : this.EventBus.getText("interface_front_img"),
                    subject: this.EventBus.getText("interface_front"),
                    explain: [
                        {
                            ex1: this.EventBus.getText("interface_front_ex1"), 
                            ex2 : this.EventBus.getText("interface_front_ex2"),
                        },
                    ], 
                },
                {
                    index: 9,
                    img : this.EventBus.getText("interface_behind_img"),
                    subject: this.EventBus.getText("interface_behind"),
                    explain: [
                        {
                            ex1: this.EventBus.getText("interface_behind_ex1"), 
                            ex2 : this.EventBus.getText("interface_behind_ex2"),
                        },
                    ], 
                },
            ]
        }
    },
    methods: {
        push(index){
            this.subject = this.datas[index].subject
            this.img = this.datas[index].img
            this.explain = [this.datas[index].explain[index].ex1, this.datas[index].explain[index].ex2]
        }
    }
}
</script>

<style scoped>
    .introduction{
        margin: 7vw auto;
        text-align: center;
    }

    h1 {
        color: #2C2C2C;
        font-size: 27px;
        font-weight: 700;
        margin: 50px;
    }
    h2{
        font-weight: 700;
        color: #5E5E5E;
        font-size: 21px;
        letter-spacing: 0.1rem;
    }

    img {
        width: 1300px;
    }
    .back img{
        margin-left: 100px;
        width: 35px;
        box-shadow: none;
        display: flex;
        position: fixed;
    }
    
    p{
        font-size: 17px;
    }

    .container{
        /* margin-top: 200px; */
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
    }

    .container img{
        width: 900px;
        margin-bottom: 50px;
    }

    .item {
        width: 850px;
        /* height: 350px; */
        background-color: #F5F5F5;
        text-align: center;
        border-radius: 70px;
        box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.08);
        margin-bottom: 60px;
        padding: 2vw;

    }

    .item img{
        box-shadow: none;
        margin: 0;
        width: 50%;
    }

    .item p{
        font-size: 15px;
        line-height: 0.8rem;
    }


</style>


// WEBPACK FOOTER //
// src/pages/tutorial_functions/function_interface.vue